export default "__VITE_ASSET__IN8AcNpV__"